import { FC } from 'react';

import { IconPreloaded } from './Icon';
import { SvgIcon } from './SvgIcon.type';
import { SvgPreloadedIcon } from './SvgPreloadedIcon';

export const IconSharePreloaded = () => (
  <SvgPreloadedIcon name="share" viewBox="0 0 24 24">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17 10C18.6569 10 20 8.65685 20 7C20 5.34315 18.6569 4 17 4C15.3431 4 14 5.34315 14 7C14 7.19168 14.018 7.37916 14.0523 7.56084L9.34486 10.1286C8.79514 9.44067 7.94903 9 7 9C5.34315 9 4 10.3431 4 12C4 13.6569 5.34315 15 7 15C7.94903 15 8.79513 14.5593 9.34486 13.8714L14.0523 16.4392C14.018 16.6208 14 16.8083 14 17C14 18.6569 15.3431 20 17 20C18.6569 20 20 18.6569 20 17C20 15.3431 18.6569 14 17 14C15.9643 14 15.0512 14.5248 14.5121 15.323L9.89142 12.8027C9.96218 12.5472 10 12.278 10 12C10 11.722 9.96218 11.4528 9.89142 11.1973L14.5121 8.67696C15.0512 9.47517 15.9643 10 17 10ZM17 8.8C17.9941 8.8 18.8 7.99411 18.8 7C18.8 6.00589 17.9941 5.2 17 5.2C16.0059 5.2 15.2 6.00589 15.2 7C15.2 7.99411 16.0059 8.8 17 8.8ZM17 18.8C17.9941 18.8 18.8 17.9941 18.8 17C18.8 16.0059 17.9941 15.2 17 15.2C16.0059 15.2 15.2 16.0059 15.2 17C15.2 17.9941 16.0059 18.8 17 18.8ZM8.8 12C8.8 12.9941 7.99411 13.8 7 13.8C6.00589 13.8 5.2 12.9941 5.2 12C5.2 11.0059 6.00589 10.2 7 10.2C7.99411 10.2 8.8 11.0059 8.8 12Z"
    />
  </SvgPreloadedIcon>
);

export const IconShare: FC<SvgIcon> = (props) => <IconPreloaded {...props} viewBox="0 0 24 24" name="share" />;
